import { DashboardGridItem } from "./styles";
import NumberHighlight from "./NumberHighlight";
import { useGetAllSlotData } from "api/stats";
import { SlotStatistics } from "./SlotStatistics";
import { Divider } from "@mindlercare/ui-web";

type TimeslotsDashboardItemProps = {
  psychologistUserId: number;
  fromDate: Date;
  toDate: Date;
  previousFromDate: Date;
  previousToDate: Date;
  dateRangeLengthInDays: number;
};

export const TimeslotsDashboardGridItem = ({
  fromDate,
  toDate,
  previousFromDate,
  previousToDate,
  psychologistUserId: selectedPsychologistUserId,
  dateRangeLengthInDays,
}: TimeslotsDashboardItemProps): JSX.Element => {
  const { data: currentData } = useGetAllSlotData({
    fromDate: fromDate,
    toDate: toDate,
    psychologistUserId: selectedPsychologistUserId,
  });

  const { data: previousData } = useGetAllSlotData({
    fromDate: previousFromDate,
    toDate: previousToDate,
    psychologistUserId: selectedPsychologistUserId,
  });

  const slots = currentData?.slots;
  const previousSlots = previousData?.slots;

  const total = slots?.total ?? 0;
  const previousTotal = previousSlots?.total ?? 0;

  const differenceTotal = total - previousTotal;

  return (
    <DashboardGridItem>
      <NumberHighlight
        title="Timeslots"
        value={total}
        difference={{
          changeAmount: differenceTotal,
          coloring: differenceTotal > 0 ? "positive" : "negative",
          text: `compared to previous ${dateRangeLengthInDays} days`,
        }}
      />

      <Divider />
      {slots && <SlotStatistics slots={slots} />}
    </DashboardGridItem>
  );
};
